import { InputField } from 'components/Global';
import InputTelpField from 'components/Global/InputTelpField';
import UploadImageCustomOrder from 'components/Global/UploadImageCustomOrder';
import React from 'react';

const DailyServiceForm = ({
  orderData,
  setOrderData,
  isOrderConfirmation,
  numberInputOnWheelPreventChange,
  uploadImageField,
  uploadImageAction,
  ktpImageLink,
  simImageLink,
}) => {
  return (
    <>
      <h2 className="detail-penyewa__detail-penyewa-form__title">Detail Penyewa</h2>
      <div className="detail-penyewa__detail-penyewa-form__form">
        {/* input */}
        <div className="detail-penyewa__detail-penyewa-form__form__one">
          <InputField
            type="text"
            label="Nama Penyewa"
            htmlFor="nama-penyewa"
            placeholder="Tulis Nama Penyewa"
            value={orderData.user_name}
            onChange={(e) => setOrderData({ ...orderData, user_name: e.target.value })}
            disable={isOrderConfirmation}
          />
          <InputField
            type="text"
            label="Email"
            htmlFor="email-penyewa"
            placeholder="Masukan Email"
            value={orderData.email}
            onChange={(e) => setOrderData({ ...orderData, email: e.target.value })}
            disable={isOrderConfirmation}
          />
          <InputTelpField
            label="No Telpon / Whatsapp"
            htmlFor="telp-penyewa"
            value={orderData.wa_number || ''}
            onChange={(e) => setOrderData({ ...orderData, wa_number: e.target.value })}
            disable={isOrderConfirmation}
            countryCodeValue={orderData.phone_country_code}
            onSelectCountry={(code) => setOrderData({ ...orderData, phone_country_code: code })}
            onWheel={numberInputOnWheelPreventChange}
          />
        </div>
        {/* upload image */}
        <div className="detail-penyewa__detail-penyewa-form__form__two">
          {uploadImageField.map((item) => (
            <div key={item.id}>
              <div>
                <h3>
                  {item.title} {item.title === 'SIM' && `(Opsional)`}
                </h3>
              </div>
              {/* upload image field */}
              <UploadImageCustomOrder
                htmlFor={item.title}
                uploadAction={uploadImageAction}
                imageFile={item.title === 'KTP' ? ktpImageLink : simImageLink}
                base64={true}
                disable={isOrderConfirmation}
              />
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default DailyServiceForm;
